const axios = require("axios");
const config = require("./config");
const instance = axios.create({
    baseURL: config.baseURL,
    timeout: config.timeout,
});

const loadAll = ({ cnn = "Datawarehouse", href = "#", filter = null }) => {
    if (filter) {
        filter.cnn = cnn;
        filter.projectName = config.projectName;
    };
    let resolve;
    let p = new Promise(r => resolve = r);
    instance.post(href, filter).then((res) => {
        if (res.status === 200) resolve(res.data);
        else resolve({ error: res });
    }).catch((error) => {
        console.log("api.net.data.error", error);
        resolve({ error });
    });

    return p;
};

const load = (cnn) => {
    let obj = {
        list: ({ storeName, filter }) => loadAll({ cnn, href: "/Data/Load/List", filter: { storeName, filter } }),
        multiList: ({ storeName, filter }) => loadAll({ cnn, href: "/Data/Load/MultiList", filter: { storeName, filter } }),
        topOne: ({ storeName, filter }) => loadAll({ cnn, href: "/Data/Load/TopOne", filter: { storeName, filter } }),
        ip: () => loadAll({ cnn, href: "/Data/Load/MyIP" }),
    };

    return obj;
};

module.exports = {
    bot: {
        load: load("core.es6.vn"),
    },
    link: {
        load: load("link.es6.vn"),
    },
    seo: {
        load: load("seo.es6.vn"),
    },
    warehouse: {
        load: load("dw.es6.vn"),
    },
};


// WEBPACK FOOTER //
// src/utils/api/net/api.net.data.js